import { emitRecoAddToCartButtonLabelEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels) => {
    const { labels } = cinemaTracking;
    const parsedCinemaIndex = Number.parseInt(cinemaIndex, 10);
    const featureNumber = Number.isNaN(parsedCinemaIndex) ? undefined : parsedCinemaIndex === 99 ? 99 : parsedCinemaIndex + 1;

    return {
        ...cinemaTracking,
        position: parseInt(featureIndex, 10),
        status: "visible",
        labels: {
            ...labels,
            ...(featureNumber && { promo_FeatureNumber: [`${featureNumber}`] }),
            promo_RecoAddToCartButton: "visible",
            promo_FilledSlots: labels.promo_FilledSlots,
            ...additionalTrackingLabels,
        },
    };
};

export default (cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels) => {
    const event = {
        name: "scroll",
        features: [buildCinema(cinemaTracking, featureIndex, cinemaIndex, additionalTrackingLabels)],
    };

    emitRecoAddToCartButtonLabelEvent(event);
};
